import * as ss from 'superstruct';

/**
 * Holds the configuration information for an input stream source.
 *
 * Shape depends on the source (dictated by name).
 */
export const InputStreamSourceConfig = ss.intersection([
  ss.type({
    /** Name of the source. */
    name: ss.string(),
  }),
  ss.record(
    ss.string(),
    ss.optional(
      ss.nullable(
        ss.union([
          ss.string(),
          ss.number(),
          ss.boolean(),
          ss.array(ss.union([ss.string(), ss.number()])),
        ]),
      ),
    ),
  ),
]);

export type InputStreamSourceConfig = ss.Infer<typeof InputStreamSourceConfig>;
